module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/telephone.png?26dd3b4d549d7b4f218d644244e114c0";